import $ from 'jquery';

$(document).ready(function() {

//SETTING SESSION STORAGE IS /TRUCKS-VEHICLES IS REACHED FROM HOME PAGE BUTTON
    
    $('#getPersonal').on('click', function() {
        sessionStorage.setItem("personal", "true");
    });

    var x = sessionStorage.getItem("personal");
   

    if (window.location.pathname === "/trucks-vehicles/" && x === "true") {
        $("#personal").addClass('active');
        $("#personalCat").addClass('display');
        $("#business").removeClass('active');
        $("#businessCat").removeClass('display');
       window.scrollTo(0, 850);
    }
    if (window.location.pathname != "/trucks-vehicles/"){
         sessionStorage.removeItem("personal");
    }
   

});


// WEBPACK FOOTER //
// ./scripts/home.js